import {v4 as uuidv4} from 'uuid';
export const gstOwnerOptions = [
  {label: 'Self', value: 'Self'},
  {label: 'Client', value: 'Client'},
];

export const indianStates = [
  {label: 'Andhra Pradesh', value: 'Andhra Pradesh'},
  {label: 'Arunachal Pradesh', value: 'Arunachal Pradesh'},
  {label: 'Assam', value: 'Assam'},
  {label: 'Bihar', value: 'Bihar'},
  {label: 'Chhattisgarh', value: 'Chhattisgarh'},
  {label: 'Goa', value: 'Goa'},
  {label: 'Gujarat', value: 'Gujarat'},
  {label: 'Haryana', value: 'Haryana'},
  {label: 'Himachal Pradesh', value: 'Himachal Pradesh'},
  {label: 'Jharkhand', value: 'Jharkhand'},
  {label: 'Karnataka', value: 'Karnataka'},
  {label: 'Kerala', value: 'Kerala'},
  {label: 'Madhya Pradesh', value: 'Madhya Pradesh'},
  {label: 'Maharashtra', value: 'Maharashtra'},
  {label: 'Manipur', value: 'Manipur'},
  {label: 'Meghalaya', value: 'Meghalaya'},
  {label: 'Mizoram', value: 'Mizoram'},
  {label: 'Nagaland', value: 'Nagaland'},
  {label: 'Odisha', value: 'Odisha'},
  {label: 'Punjab', value: 'Punjab'},
  {label: 'Rajasthan', value: 'Rajasthan'},
  {label: 'Sikkim', value: 'Sikkim'},
  {label: 'Tamil Nadu', value: 'Tamil Nadu'},
  {label: 'Telangana', value: 'Telangana'},
  {label: 'Tripura', value: 'Tripura'},
  {label: 'Uttar Pradesh', value: 'Uttar Pradesh'},
  {label: 'Uttarakhand', value: 'Uttarakhand'},
  {label: 'West Bengal', value: 'West Bengal'},
  {label: 'Delhi', value: 'Delhi'},

  // Union Territories
  {label: 'Andaman and Nicobar Islands', value: 'Andaman and Nicobar Islands'},
  {label: 'Chandigarh', value: 'Chandigarh'},
  {
    label: 'Dadra and Nagar Haveli and Daman and Diu',
    value: 'Dadra and Nagar Haveli and Daman and Diu',
  },
  {label: 'Lakshadweep', value: 'Lakshadweep'},
  {label: 'Jammu and Kashmir', value: 'Jammu and Kashmir'},
  {label: 'Ladakh', value: 'Ladakh'},
  {label: 'Puducherry', value: 'Puducherry'},
];

export const manageGstTable = {
  tableHeading: [
    {
      id: uuidv4(),
      headingTxt: 'GST Owner',
      headingWidth: '80px',
    },
    {
      id: uuidv4(),
      headingTxt: 'GST Number',
      headingWidth: '144px',
    },
    {
      id: uuidv4(),
      headingTxt: 'Company Name',
      headingWidth: '170px',
    },
    {
      id: uuidv4(),
      headingTxt: 'State',
      headingWidth: '112px',
    },
    {
      id: uuidv4(),
      headingTxt: 'Address',
      headingWidth: '170px',
    },
  ],
};
